export function toEmbedUrl(url) {
  if (!url) return "";
  try {
    if (url.includes("youtube.com/watch")) {
      const id = new URL(url).searchParams.get("v");
      return `https://www.youtube.com/embed/${id}`;
    }
    if (url.includes("youtu.be/")) {
      const id = url.split("youtu.be/")[1].split(/[?&]/)[0];
      return `https://www.youtube.com/embed/${id}`;
    }
    if (url.includes("/shorts/")) {
      const id = url.split("/shorts/")[1].split(/[?&/]/)[0];
      return `https://www.youtube.com/embed/${id}`;
    }
    if (url.includes("vimeo.com/") && !url.includes("player.vimeo.com")) {
      const id = url.split("vimeo.com/")[1].split(/[?&/]/)[0];
      return `https://player.vimeo.com/video/${id}`;
    }
    return url;
  } catch {
    return url;
  }
}
